<template>
  <div>
    <v-data-table
      v-if="manifests"
      :headers="headers"
      :items="renderedManifests"
      :search="search"
      :sort-by="'id'"
      :sort-desc="[true]"
    >

      <template v-slot:item="props">
        <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
          <td style="text-align: center" v-for="(header, index) in headers" :key="index"
              v-if="header.value!=='original'">
            {{props.item[header.value]}}
          </td>
          <td style="text-align: center">
            <v-tooltip top color="orange darken-2" v-if="props.item.status === 0">
              <template v-slot:activator="{ on }">
                <v-icon color="orange" v-on="on" class="pl-1">
                  hourglass_empty
                </v-icon>
              </template>
              <span>Manifest still importing, please refresh and wait until completed</span>
            </v-tooltip>

            <template v-else>
            <v-tooltip top color="secondary" v-if="downloadPermission">
              <template v-slot:activator="{ on }">
                <v-icon color="green" @click="getCSV(props.item)" v-on="on" class="pl-1">
                  cloud_download
                </v-icon>
              </template>
              <span>Download the original CSV</span>
            </v-tooltip>
            <v-tooltip top color="secondary" v-if="downloadPermission">
              <template v-slot:activator="{ on }">
                <v-icon color="red" @click="getRejectFile(props.item)" v-on="on" class="pl-1">
                  cloud_download
                </v-icon>
              </template>
              <span>Download Reject file</span>
            </v-tooltip>
            <v-tooltip top color="secondary" v-if="downloadPermission">
              <template v-slot:activator="{ on }">
                <v-icon color="green" @click="getLabels(props.item)" v-on="on" class="pl-1">
                  description
                </v-icon>
              </template>
              <span>Download Box Labels Brcode</span>
            </v-tooltip>
<!--            <v-tooltip top color="secondary" v-if="exportPermission">-->
              <v-tooltip top color="secondary" v-if="downloadPermission">
              <template v-slot:activator="{ on }">
                <v-icon color="blue" @click="getExport(props.item)" v-on="on" class="pl-1">
                  cloud_download
                </v-icon>
              </template>
              <span>Download Export</span>
            </v-tooltip>
            <v-tooltip top color="secondary" >
              <template v-slot:activator="{ on }">
                <span v-on="on" class="d-inline-block">
                <v-icon :disabled="!deletePermission || (!isInternalUser && props.item.pick_pack)"  color="red" @click="openDeleteDialog(props.item)" v-on="on" class="pl-1">
                  delete
                </v-icon>
                  </span>
              </template>
              <span>Delete Manifest</span>
            </v-tooltip>
            </template>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete the manifest nº {{toBeDeleted.id}}.<br>
          This action cannot be undone.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="deleteDialog=false">Cancel Deletion</v-btn>
          <v-btn text color="red" @click="deleteManifest">Delete Manifest</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="downLooadDialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title class="justify-center" style="position: relative">
          <h2>Download Box Labels BrCode</h2>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
          <v-container container--fluid grid-list-xl pb-0>
            <v-form
              ref="form"
            >
              <v-row  align="center" class="d-flex align-center">
                <v-col cols="6" md="5">
                  <v-select
                    label="Number Label Per Page"
                    :items="numberLabels"
                    item-text="name"
                    item-value="id"
                    v-model="numberLabel"
                  ></v-select>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="6" md="3">
                <v-tooltip top color="secondary" v-if="downloadPermission">
                  <template v-slot:activator="{ on }">
                    <v-icon color="green" @click="downloadLabels()" v-on="on" class="pl-1">
                      description
                    </v-icon>
                  </template>
                  <span>Download Box Labels BrCode</span>
                </v-tooltip>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="6" md="3">
                  <v-tooltip top color="secondary" v-if="downloadPermission">
                    <template v-slot:activator="{ on }">
                      <v-icon  v-show="isAdmin" color="blue" @click="downloadLabelsQrCode()" v-on="on" class="pl-1">
                        book
                      </v-icon>
                    </template>
                    <span>Download Box Labels QrCode</span>
                  </v-tooltip>
                </v-col>

              </v-row>



<!--              <v-row  align="center" class="d-flex align-center">-->
<!--                <v-col cols="6" md="5">-->
<!--                  <v-select-->
<!--                    label="Barcode Size Per Label"-->
<!--                    :items="numberBarcodeSize"-->
<!--                    item-text="name"-->
<!--                    item-value="value"-->
<!--                    v-model="barcodeSize"-->
<!--                  ></v-select>-->
<!--                </v-col>-->
<!--                <v-spacer></v-spacer>-->
<!--                <v-col cols="6" md="6">-->

<!--                </v-col>-->
<!--              </v-row>-->

              <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                <v-col cols="12" md="3" class="text-center">
                </v-col>
                <v-col cols="12" md="3" class="text-center">
                  <v-btn
                    text
                    @click="downLooadDialog=false"
                    color="blue darken-1"
                  >Close
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from 'axios'
// @vuese
// Table containing all the manifests that have been previously uploaded. This table is used in the ManifestsPage.
// @group Manifest
export default {
  name: "ManifestTable",
  props: {
    isInternalUser: Boolean,
    search: String,
    manifests: Array,
  },
  data() {
    return {
      toBeDeleted: {id: null},
      deleteDialog: false,
      downLooadDialog: false,
      numberLabels:[1,2,4],
      numberLabel:2,
      // numberBarcodeSize:[
      //   { name: 'Large', value: 5 },
      //   { name: 'XLarge', value: 2 }],
      barcodeSize:5,
      item:null
    }
  },
  computed: {
    headers() {
      let headers = [
        {text: 'ID', value: 'id', align: 'center', sortable: true},
        {text: 'Delivery Date', value: 'delivery_date', align: 'center', sortable: true},
        {text: 'Region Name', value: 'region_name', align: 'center', sortable: true},
        {text: 'Uploaded By', value: 'uploaded_by_name', align: 'center', sortable: true},
        {text: 'Upload Time', value: 'time', align: 'center', sortable: true},
        {text: 'Time Window', value: 'time_window', align: 'center', sortable: true},
        {text: 'Deliveries', value: 'delivery_count', align: 'center', sortable: true},
      ];
      if (this.isInternalUser) {
        headers.push({text: 'Client Name', value: 'client_name', align: 'center', sortable: false});
      }
      if (this.exportPermission || this.deletePermission || this.downloadPermission) {
        headers.push({text: 'Actions', value: 'original', align: 'center', sortable: false});
      }
      return headers;
    },
    renderedManifests() {
      let data = [];
      this.manifests.forEach(function (manifest) {
        manifest.delivery_date === null ? null : (new Date(manifest.delivery_date)).toLocaleDateString();
        manifest.time = (new Date(manifest.time + ' UTC')).toLocaleString();
        data.push(manifest);
      });
      return data;
    },
    exportPermission() {
      return this.$store.getters['auth/hasPermission']('export_download');
    },
    deletePermission() {
      return this.$store.getters['auth/hasPermission']('manifest_delete');
    },
    downloadPermission() {
      return this.$store.getters['auth/hasPermission']('manifest_download');
    },
    isAdmin(){
      return (this.$store.getters['auth/isAdmin'] || (this.item && this.item.client_id === 154));
    }
  },
  methods: {
    // @vuese
    // Gets the csv content of the manifest the user clicked on from the API and downloads a csv file that contains
    // the original manifest .
    // @arg Takes the manifest Object on which the user clicked as an argument.
    getCSV(item) {
      window.open(process.env.API_URL + '/manifests/' + item.id + '/csv?key=' + encodeURI(this.$store.state.auth.key), '_blank')
    },
    getRejectFile(item) {
      axios.get(process.env.API_URL + '/manifests/' + item.id + '/rejects')
        .then((response) => {
          if (response.status === 404) {
            this.$store.commit('displaySnackbar', 'No rejects found for this manifest');
            return;
          }

          window.open(response.data.signedURL, '_blank');
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$store.commit('displaySnackbar', 'No rejects found for this manifest');
            return;
          }
          this.$store.commit('displaySnackbar', 'ERROR: ' + error);
        })
    },
    getLabels(item) {
      this.item = item;
      this.downLooadDialog = true;
    },
    downloadLabels(){
      window.open(process.env.API_URL + '/manifests/' + this.item.id + '/labels?number='+this.numberLabel +
        '&&barcodeSize=' + this.barcodeSize + '&&key=' + encodeURI(this.$store.state.auth.key), '_blank')
    },
    downloadLabelsQrCode(){
      window.open(process.env.API_URL + '/manifests/' + this.item.id + '/labelsQrcode?number='+this.numberLabel +
        '&&barcodeSize=' + this.barcodeSize + '&&key=' + encodeURI(this.$store.state.auth.key), '_blank')
    },
    // @vuese
    // Gets the export of the manifest the user clicked on from the API and downloads a csv file that contains
    // the export data.
    // @arg Takes the manifest Object on which the user clicked as an argument.
    getExport(item) {
      window.open(process.env.API_URL + '/manifests/' + item.id + '/export?key=' + encodeURI(this.$store.state.auth.key), '_blank')
    },
    // @vuese
    // Stores the manifest the user clicked on in toBeDeleted variable and displays the delete dialog.
    openDeleteDialog(item) {
      this.toBeDeleted = item;
      this.deleteDialog = true;
    },
    // @vuese
    // Deletes the manifest from the array of manifests displayed in the table and POST those changes on the API.
    deleteManifest() {
      axios.delete(process.env.API_URL + '/manifests/' + this.toBeDeleted.id)
        .then((response) => {
          this.$store.commit('displaySnackbar', 'Manifest nº' + this.toBeDeleted.id + ' deleted.');
          this.deleteDialog = false;
          this.toBeDeleted = {id: null};
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
        })
    }
  },
}
</script>

<style scoped>

.v-select, .v-icon {
  padding-top: 0;
  padding-bottom: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/util/Manifest/ManifestTable.vue